import { createContext, Dispatch } from 'react';
import { ICardState } from './sellerListingCardReducer';

export interface ISellerListingCardContext {
  cardState: ICardState;
  dispatch?: Dispatch<any>;
  listingQuery: any;
}

const SellerListingCardContext = createContext<ISellerListingCardContext>({
  cardState: {
    loadingListing: false,
    listing: null,
    toast: {
      isOpen: false,
      message: '',
      isSuccess: true,
    },
  },
  dispatch: () => {},
  listingQuery: null,
});
  

export default SellerListingCardContext;
